"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('rotate', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("polygon", {
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    points: "12 24 42 24 42 42 12 42"
  }), _react.default.createElement("g", {
    transform: "translate(6.000000, 7.864012)",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("polyline", {
    points: "0 0.135987835 0 9.13598783 9 9.13598783"
  })), _react.default.createElement("path", {
    d: "M38.4747483,13.2984546 C35.1956257,8.87049495 29.9330329,6 24,6 C18.1787623,6 13.0029367,8.76333758 9.71271957,13.0498164 L6,17",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }))));
});

exports.default = _default;